import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { SEO } from '../../seo/SEO';

/**
 * Guards /pos/* routes. A valid session is either:
 *   - a scoped POS token (user.is_pos)
 *   - a full admin token (user.is_admin) — lets admins preview the POS UX
 *     from the web without needing a PIN
 * Anything else → /pos/login.
 */
export const PosRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-900 flex items-center justify-center" data-testid="pos-route-loading">
        <SEO title="POS" noIndex includeRestaurantSchema={false} />
        <Loader2 className="h-8 w-8 animate-spin text-white" />
      </div>
    );
  }

  if (!user || !(user.is_pos || user.is_admin)) {
    return <Navigate to="/pos/login" replace />;
  }

  return (
    <>
      <SEO title="POS" noIndex includeRestaurantSchema={false} />
      {children}
    </>
  );
};

export default PosRoute;
